// (about.js code remains the same as the previous version)
// ...
import React from 'react';
import './about.css';
import { FaHeart, FaUserCheck, FaLock, FaChartBar, FaArrowRight, FaBolt } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const keyMetrics = [
  { value: "90 Sec", label: "Decision Time", icon: <FaBolt /> }, // Faster decision
  { value: "1 Hour", label: "Fund Transfer Guarantee", icon: <FaLock /> }, // Transfer guarantee
  { value: "No Stress", label: "Credit Score Friendly", icon: <FaUserCheck /> }, // Low credit score stress
];

const About = () => {
  return (
    <section className="au-split-wrap">
      <div className="au-split-container">
        
        {/* === LEFT SIDE: Main Content (Focus on Quick Relief) === */}
        <div className="au-split-left">
          <div className="au-left-content">
            <div className="au-split-eyebrow">INSTANT CASH RELIEF <FaHeart /></div>
            <h2 className="au-split-title">
              Your <span className="au-split-highlight"> Financial Emergency, Our </span>Quick Solution
            </h2>
            <p className="au-split-intro">
              When life hits you with an unexpected bill, you need speed, not paperwork. We provide fast, reliable payday loans with minimum documentation and maximum efficiency.
            </p>

            {/* Metrics Grid */}
            <div className="au-metrics-split-grid">
              {keyMetrics.map((metric, index) => (
                <div key={index} className="au-metric-split-item">
                  <div className="au-metric-split-icon">{metric.icon}</div>
                  <p className="au-metric-split-value">{metric.value}</p>
                  <p className="au-metric-split-label">{metric.label}</p>
                </div>
              ))}
            </div>

            <Link to="/apply-now" className="au-split-cta-btn">
              Apply in 2 Minutes <FaArrowRight />
            </Link>
          </div>
        </div>

        {/* === RIGHT SIDE: Dynamic Visual Block (Highlighting Cash Amount) === */}
        <div className="au-split-right">
            <div className="au-visual-statement">
                <p className="au-stat-large">₹50K</p>
                <p className="au-stat-sub">Maximum Instant Cash</p>
            </div>
            <div className="au-visual-note">
                <FaBolt className="au-note-icon"/> Funds transferred directly to your account within 60 minutes, guaranteed.
            </div>
        </div>
        
      </div>
    </section>
  );
};

export default About;